import { Lookup } from './../../../core/domain/models/lookup';
import { GeoAddress } from './../../../core/domain/models/geo-address';
import { JobFilters } from './../../../core/domain/models/job-filters';
import { JobDetails } from './../../../core/domain/models/job-details';
import {
  GetJobsGridDataRequest,
  Job,
  JobTemplate,
  LocationsToAddInJobs,
  VehicleType
} from "../../../core/domain";
import { Vehicle } from 'planning-portal-library/src/lib/core/domain/models/vehicle-detail';


export class SetJobDetailsETAResponse {
  static readonly type = "[Jobs] Set JobDetails ETA Response";

  constructor(public payload: boolean | undefined) {
  }
}

export class GetJobs {
  static readonly type = "[Jobs] Get Jobs";

  constructor(public payload: Job[] | undefined) {
  }
}

export class IsOptimizedJob {
  static readonly type = "[Jobs] Is Optimized Jobs";

  constructor(public payload: boolean | undefined) {
  }
}

export class IsAddedNewLocation {
  static readonly type = "[Jobs] Is Added New Location";

  constructor(public payload: boolean | undefined) {
  }
}

export class SelectedJob {
  static readonly type = "[Job] Selected Job";

  constructor(public payload: Job | undefined) {
  }
}

export class GetJobLookup {
  static readonly type = "[Locations] Get Jobs Lookup";

  constructor(public payload: Lookup[] | undefined) {
  }
}

export class GetStartGeoCoordinates {
  static readonly type = "[Jobs] Get Start Geo Coordinates";

  constructor(public payload: GeoAddress | undefined) {
  }
}

export class GetEndGeoCoordinates {
  static readonly type = "[Jobs] Get End Geo Coordinates";

  constructor(public payload: GeoAddress | undefined) {
  }
}

export class GetVehicleTypes {
  static readonly type = "[Jobs] Get Vehicle Types";

  constructor(public payload: VehicleType[] | undefined) {
  }
}

export class GetJobDetails {
  static readonly type = "[Job] Get Job Details";

  constructor(public payload: JobDetails | undefined) {
  }
}


export class GetJobFilters {
  static readonly type = "[Job] Get Job Filters";

  constructor(public payload: JobFilters | undefined) {
  }
}
export class GetVehicleDetails {
  static readonly type = "[Jobs] Get Vehicle Details";

  constructor(public payload: Vehicle[] | undefined) {
  }
}
export class RemoveJobFilters {
  static readonly type = "[Job] Remove Job Filters";

  constructor() {
  }
}

export class SetJobId {
  static readonly type = "[Job] Job Id";

  constructor(public payload: string | undefined) {
  }
}

export class SetJobRequest {
  static readonly type = "[Job] Set Jobs";

  constructor(public payload: GetJobsGridDataRequest | undefined) {
  }
}

export class GetLocationsToAddInJob {
  static readonly type = "[Job] Get Locations To Add In Job";

  constructor(public payload: LocationsToAddInJobs[] | undefined) {
  }
}

export class GetSelectedLocation {
  static readonly type = "[Job] Get Selected Location In Job";

  constructor(public payload: string | undefined) {
  }
}

export class GetJobTemplate {
  static readonly type = "[Job] Get Job Template";

  constructor(public payload: JobTemplate[] | undefined) {
  }
}